/**
 * Identifies the type of Corporate Action.
 * - Tag: 292
 * - FIX Specification type: MultipleCharValue
 * - Mapped type: string
 * @readonly
 * @public
 */
export const CorporateAction = Object.freeze({
    /** Ex-Dividend */
    ExDividend: 'A',
    /** Ex-Distribution */
    ExDistribution: 'B',
    /** Ex-Rights */
    ExRights: 'C',
    /** New */
    New: 'D',
    /** Ex-Interest */
    ExInterest: 'E',
    /** Cash Dividend */
    CashDividend: 'F',
    /** Stock Dividend */
    StockDividend: 'G',
    /** Non-Integer Stock Split */
    NonIntegerStockSplit: 'H',
    /** Reverse Stock Split */
    ReverseStockSplit: 'I',
    /** Standard-Integer Stock Split */
    StandardIntegerStockSplit: 'J',
    /** Position Consolidation */
    PositionConsolidation: 'K',
    /** Liquidation Reorganization */
    LiquidationReorganization: 'L',
    /** Merger Reorganization */
    MergerReorganization: 'M',
    /** Rights Offering */
    RightsOffering: 'N',
    /** Shareholder Meeting */
    ShareholderMeeting: 'O',
    /** Spinoff */
    Spinoff: 'P',
    /** Tender Offer */
    TenderOffer: 'Q',
    /** Warrant */
    Warrant: 'R',
    /** Special Action */
    SpecialAction: 'S',
    /** Symbol Conversion */
    SymbolConversion: 'T',
    /** CUSIP / Name Change */
    CUSIP: 'U',
    /** Leap Rollover */
    LeapRollover: 'V',
    /** Succession Event */
    SuccessionEvent: 'W',
} as const);

export type CorporateAction = (typeof CorporateAction)[keyof typeof CorporateAction];
